import { ReportHandler } from "web-vitals";
import GoogleAnalyticsV2 from "./utils/GoogleAnalyticsV2";

/**
 * Get web vital rating based on metric name and value
 * @see https://web.dev/vitals/
 */
const getMetricRating = (metricName: string, value: number): string => {
  switch (metricName) {
    case "CLS":
      if (value <= 0.1) return "good";
      if (value <= 0.25) return "needs-improvement";
      return "poor";
    case "FID":
      if (value <= 100) return "good";
      if (value <= 300) return "needs-improvement";
      return "poor";
    case "FCP":
      if (value <= 1800) return "good";
      if (value <= 3000) return "needs-improvement";
      return "poor";
    case "LCP":
      if (value <= 2500) return "good";
      if (value <= 4000) return "needs-improvement";
      return "poor";
    case "TTFB":
      if (value <= 800) return "good";
      if (value <= 1800) return "needs-improvement";
      return "poor";
    default:
      return "unknown";
  }
};

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import("web-vitals").then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }

  // Send web vitals to Google Analytics with structured parameters
  if (typeof window !== "undefined") {
    import("web-vitals").then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS((metric) => {
        GoogleAnalyticsV2.trackWebVital(
          "CLS",
          metric.value,
          getMetricRating("CLS", metric.value)
        );
      });

      getFID((metric) => {
        GoogleAnalyticsV2.trackWebVital(
          "FID",
          metric.value,
          getMetricRating("FID", metric.value)
        );
      });

      getFCP((metric) => {
        GoogleAnalyticsV2.trackWebVital(
          "FCP",
          metric.value,
          getMetricRating("FCP", metric.value)
        );
      });

      getLCP((metric) => {
        GoogleAnalyticsV2.trackWebVital(
          "LCP",
          metric.value,
          getMetricRating("LCP", metric.value)
        );
      });

      getTTFB((metric) => {
        GoogleAnalyticsV2.trackWebVital(
          "TTFB",
          metric.value,
          getMetricRating("TTFB", metric.value)
        );
      });
    });
  }
};

export default reportWebVitals;
